import React, { useState, ChangeEvent } from "react";
import { useNavigate } from "react-router-dom";
import {
    Tabs,
    Tab,
    TextField,
    Button,
    MenuItem,
    Select,
    SelectChangeEvent,
    CardMedia,
    Input,
    Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";

const EditVendor = () => {
    const navigate = useNavigate();

    const [tabIndex, setTabIndex] = useState(0);
    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabIndex(newValue);
    };

    const [image, setImage] = useState<string>("");
    const [fileName, setFileName] = useState<string>("");

    const [country, setCountry] = useState("default");
    const [state, setState] = useState("default");
    const [city, setCity] = useState("default");

    return (
        <>
            <div className="main_title">
                <h1>Edit Vendor</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
                    <button onClick={() => navigate("/manage-vendors")}>Manage Vendors</button> - Edit Vendor
                </p>
            </div>

            {/* Tabs Section */}
            <Box className="custom_tabs1">
                <Tabs
                    value={tabIndex}
                    onChange={handleTabChange}
                    className="custom_tabs_links"
                >
                    <Tab label="General Details" />
                    <Tab label="Documents" />
                    <Tab label="Bank Details" />
                    <Tab label="Commission" />
                </Tabs>
            </Box>

            <div className="cards">
                {/* ========== General Details Tab ========== */}
                {tabIndex === 0 && (
                    <div className="form">
                        <div className="gap_p">
                            {/* Upload Business Photo/Logo */}
                            <div className="control_group w_100">
                                <label htmlFor="vendor-logo">
                                    Photo/Logo of the Business <span className="req">*</span>
                                </label>
                                {image ? (
                                    <div className="upload_image">
                                        <div className="upload_image_holder no_radius">
                                            <figure>
                                                <CardMedia component="img" image={image} alt="Vendor Logo" />
                                            </figure>
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    setImage("");
                                                    setFileName("");
                                                }}
                                                style={{ border: 'none', background: 'transparent', cursor: 'pointer', padding: 0 }}
                                                aria-label="Remove image"
                                            >
                                                <CloseIcon />
                                            </button>
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        <Input
                                            sx={{ display: "none" }}
                                            id="vendor-logo"
                                            type="file"
                                            inputProps={{ accept: "image/png,image/jpeg" }}
                                            onChange={(event: ChangeEvent<HTMLInputElement>) => {
                                                const files = event.target.files;
                                                if (files && files[0].type.includes("image")) {
                                                    setFileName(files[0].name);
                                                    setImage(URL.createObjectURL(files[0]));
                                                }
                                            }}
                                        />
                                        <label className="upload_image" htmlFor="vendor-logo">
                                            <span className="upload_image_holder no_radius">
                                                <figure className="add_img">
                                                    <img
                                                        src="/static/images/placeholder.png"
                                                        alt="placeholder"
                                                    />
                                                    <span className="upload_img_icon">
                                                        <img
                                                            src="/static/images/edit2_icon.svg"
                                                            alt="edit"
                                                        />
                                                    </span>
                                                </figure>
                                            </span>
                                        </label>
                                    </>
                                )}
                            </div>

                            {/* Owner and Store Name */}
                            <div className="control_group w_50">
                                <label htmlFor="owner-name">
                                    Owner Name <span className="req">*</span>
                                </label>
                                <TextField id="owner-name" placeholder="Enter Owner Name" fullWidth />
                            </div>

                            <div className="control_group w_50">
                                <label htmlFor="store-name">
                                    Store Name <span className="req">*</span>
                                </label>
                                <TextField id="store-name" placeholder="Enter Store Name" fullWidth />
                            </div>

                            {/* Contact Info */}
                            <div className="control_group w_50">
                                <label htmlFor="contact-phone">
                                    Contact Phone <span className="req">*</span>
                                </label>
                                <PhoneInput
                                    country={"in"}
                                    placeholder="Enter Contact Phone"
                                    inputProps={{ name: "phone", id: "contact-phone", required: true }}
                                    inputStyle={{ width: "100%" }}
                                />
                            </div>

                            <div className="control_group w_50">
                                <label htmlFor="contact-email">
                                    Contact Email <span className="req">*</span>
                                </label>
                                <TextField id="contact-email" placeholder="Enter Contact Email" fullWidth />
                            </div>

                            {/* Bio */}
                            <div className="control_group w_100">
                                <label htmlFor="vendor-bio">
                                    Bio <span className="req">*</span>
                                </label>
                                <TextField
                                    id="vendor-bio"
                                    placeholder="Enter Business Bio"
                                    fullWidth
                                    multiline
                                    minRows={3}
                                />
                            </div>

                            {/* Store Timings */}
                            <div className="control_group w_50">
                                <label htmlFor="opening-time">
                                    Store Opening Time <span className="req">*</span>
                                </label>
                                <TextField id="opening-time" type="time" fullWidth />
                            </div>

                            <div className="control_group w_50">
                                <label htmlFor="closing-time">
                                    Store Closing Time <span className="req">*</span>
                                </label>
                                <TextField id="closing-time" type="time" fullWidth />
                            </div>

                            {/* Address */}
                            <div className="control_group w_50">
                                <label htmlFor="address-line1">
                                    Address Line 1 <span className="req">*</span>
                                </label>
                                <TextField id="address-line1" placeholder="Enter Address Line 1" fullWidth />
                            </div>

                            <div className="control_group w_50">
                                <label htmlFor="address-line2">Address Line 2</label>
                                <TextField id="address-line2" placeholder="Enter Address Line 2" fullWidth />
                            </div>

                            {/* Country, State, City, Zip */}
                            <div className="control_group w_25">
                                <label htmlFor="country">
                                    Country <span className="req">*</span>
                                </label>
                                <Select
                                    id="country"
                                    value={country}
                                    onChange={(e: SelectChangeEvent) => setCountry(e.target.value)}
                                    fullWidth
                                >
                                    <MenuItem disabled value="default">
                                        Select Country
                                    </MenuItem>
                                    <MenuItem value="india">India</MenuItem>
                                    <MenuItem value="usa">USA</MenuItem>
                                    <MenuItem value="uk">UK</MenuItem>
                                </Select>
                            </div>

                            <div className="control_group w_25">
                                <label htmlFor="state">
                                    State <span className="req">*</span>
                                </label>
                                <Select
                                    id="state"
                                    value={state}
                                    onChange={(e: SelectChangeEvent) => setState(e.target.value)}
                                    fullWidth
                                >
                                    <MenuItem disabled value="default">
                                        Select State
                                    </MenuItem>
                                    <MenuItem value="maharashtra">Maharashtra</MenuItem>
                                    <MenuItem value="gujarat">Gujarat</MenuItem>
                                    <MenuItem value="delhi">Delhi</MenuItem>
                                </Select>
                            </div>

                            <div className="control_group w_25">
                                <label htmlFor="city">
                                    City <span className="req">*</span>
                                </label>
                                <Select
                                    id="city"
                                    value={city}
                                    onChange={(e: SelectChangeEvent) => setCity(e.target.value)}
                                    fullWidth
                                >
                                    <MenuItem disabled value="default">
                                        Select City
                                    </MenuItem>
                                    <MenuItem value="mumbai">Mumbai</MenuItem>
                                    <MenuItem value="pune">Pune</MenuItem>
                                    <MenuItem value="ahmedabad">Ahmedabad</MenuItem>
                                </Select>
                            </div>

                            <div className="control_group w_25">
                                <label htmlFor="zip-code">
                                    Zip Code <span className="req">*</span>
                                </label>
                                <TextField id="zip-code" placeholder="Enter Zip Code" fullWidth />
                            </div>
                        </div>

                        <div className="form_btn mt_30">
                            <Button className="btn btn_primary">Submit</Button>
                        </div>
                    </div>
                )}

                {/* ========== Documents Tab ========== */}
                {tabIndex === 1 && (
                    <div className="form">
                        <div className="gap_p">
                            <div className="control_group w_50">
                                <label htmlFor="doc-name">
                                    Document Name <span className="req">*</span>
                                </label>
                                <TextField id="doc-name" placeholder="Enter Name" fullWidth />
                            </div>

                            <div className="control_group w_50">
                                <label htmlFor="expiry-date">
                                    Expiry Date <span className="req">*</span>
                                </label>
                                <TextField id="expiry-date" type="date" fullWidth />
                            </div>

                            {/* Upload Front Side */}
                            <div className="control_group w_50">
                                <label htmlFor="doc-front">
                                    Upload Front Side <span className="req">*</span>
                                </label>
                                <Input
                                    sx={{ display: "none" }}
                                    id="doc-front"
                                    type="file"
                                    inputProps={{ accept: "image/png,image/jpeg" }}
                                />
                                <label htmlFor="doc-front" className="upload_image v2">
                                    <span className="upload_image_holder no_radius">
                                        <figure className="add_img">
                                            <img src="/static/images/placeholder.png" alt="upload front" />
                                            <span className="upload_img_icon">
                                                <img src="/static/images/edit2_icon.svg" alt="edit" />
                                            </span>
                                        </figure>
                                    </span>
                                </label>
                            </div>

                            {/* Upload Back Side */}
                            <div className="control_group w_50">
                                <label htmlFor="doc-back">
                                    Upload Back Side <span className="req">*</span>
                                </label>
                                <Input
                                    sx={{ display: "none" }}
                                    id="doc-back"
                                    type="file"
                                    inputProps={{ accept: "image/png,image/jpeg" }}
                                />
                                <label htmlFor="doc-back" className="upload_image v2">
                                    <span className="upload_image_holder no_radius">
                                        <figure className="add_img">
                                            <img src="/static/images/placeholder.png" alt="upload back" />
                                            <span className="upload_img_icon">
                                                <img src="/static/images/edit2_icon.svg" alt="edit" />
                                            </span>
                                        </figure>
                                    </span>
                                </label>
                            </div>
                        </div>

                        <div className="form_btn mt_30">
                            <Button className="btn btn_primary">Submit</Button>
                        </div>
                    </div>
                )}

                {/* ========== Bank Details Tab ========== */}
                {tabIndex === 2 && (
                    <div className="form">
                        <div className="gap_p">
                            <div className="control_group w_50">
                                <label htmlFor="bank-name">
                                    Bank Name <span className="req">*</span>
                                </label>
                                <TextField id="bank-name" placeholder="Enter Bank Name" fullWidth />
                            </div>
                            <div className="control_group w_50">
                                <label htmlFor="account-holder">
                                    Account Holder’s Name <span className="req">*</span>
                                </label>
                                <TextField id="account-holder" placeholder="Enter Name" fullWidth />
                            </div>
                            <div className="control_group w_50">
                                <label htmlFor="branch-name">
                                    Branch Name <span className="req">*</span>
                                </label>
                                <TextField id="branch-name" placeholder="Enter Branch Name" fullWidth />
                            </div>
                            <div className="control_group w_50">
                                <label htmlFor="bank-code">
                                    Bank Code <span className="req">*</span>
                                </label>
                                <TextField id="bank-code" placeholder="Enter Bank Code" fullWidth />
                            </div>
                        </div>
                        <div className="form_btn mt_30">
                            <Button className="btn btn_primary">Submit</Button>
                        </div>
                    </div>
                )}

                {/* ========== Commission Tab ========== */}
                {tabIndex === 3 && (
                    <div className="form">
                        <div className="gap_p">
                            <div className="control_group w_50">
                                <label htmlFor="commission">
                                    Commission Percentage <span className="req">*</span>
                                </label>
                                <TextField id="commission" placeholder="Enter Commission" fullWidth />
                            </div>
                        </div>
                        <div className="form_btn mt_30">
                            <Button className="btn btn_primary">Submit</Button>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default EditVendor;
